<!--
 * @Description: 登录页
 * @Author: ma.cq
 * @LastEditors: ma.cq
 * @Date: 2019-04-12 14:37:26
 * @LastEditTime: 2019-04-18 10:00:12
 -->
<template>
  <div class="login" v-if="reload">
    <div class="top-bar">
      <img src="@/assets/imgs/headNav/logo.png">
      <span>京博商城B2B管理平台</span>
    </div>
    <div class="container clearfix">
      <img src="../../assets/imgs/login/login-bg.png" alt="" class="img-login">
      <div class="login-panel">
        <div class="title">京博石化管理平台</div>
        <div class="panel" v-if="!isDingDing">
          <div class="slogn">欢迎登录</div>
          <el-form ref="form" :model="form" :rules="rules" refs="form">
            <el-form-item prop="account">
              <el-input v-model="form.account" placeholder="请输入用户名或手机号"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="form.password" placeholder="请输入密码" type="password"></el-input>
            </el-form-item>
            <el-form-item prop="verifyCode">
              <el-row :gutter="10">
                <el-col :span="16">
                  <el-input
                    v-model="form.verifyCode"
                    placeholder="请输入验证码"
                    @keyup.enter.native="handleSubmit"></el-input>
                </el-col>
                <el-col :span="8">
                  <img :src="imgCodeSrc" @click="getVerifyCode" class="img-code" alt="图片验证码">
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" class="submit" @click="handleSubmit">登录</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="auto-login" v-else>
          自动登录中...
        </div>
      </div>
    </div>
    <change-password-dialog :show.sync="passwordDialogShow"></change-password-dialog>
  </div>
</template>

<script>
import * as dd from 'dingtalk-jsapi'
import { mapActions } from 'vuex'
import { checkCodeold } from '@/common/verify'
import changePasswordDialog from './changePasswordDialog'

// import { checkCode } from '@/common/verify'
export default {
  name: 'login',
  components: { changePasswordDialog },
  data () {
    return {
      isDingDing: false,
      passwordDialogShow: false,
      form: {
        account: '',
        password: '',
        verifyCode: ''
      },
      imgCode: {},
      rules: {
        account: [
          { required: true, message: '账号不能为空' },
          { pattern: checkCodeold, message: '账号格式有误，请重新输入' }
        ],
        // password: [
        //   { required: true, message: '密码不能为空' },
        //   { pattern: checkCode, message: '密码格式有误，请重新输入' }
        // ],
        verifyCode: [
          { required: true, message: '验证码不能为空' }
        ]
      },
      reload: false
    }
  },
  computed: {
    imgCodeSrc () {
      return `data:img/jpg;base64,${this.imgCode.imageCodeBase}`
    }
  },
  created () {
    // 用作退出登录时判断store是否清空
    if (this.$store.state.router.hasAdd) {
      return this.$router.go(0) // 清store
    }
    this.reload = true
  },
  methods: {
    ...mapActions(['login', 'ddLogin', 'getImgVerifyCode', 'getRegionJson', 'getUserPermission']),
    handleSubmit () {
      const me = this
      this.$refs.form.validate(async val => {
        if (val) {
          const params = {
            ...this.form,
            imageKey: this.imgCode.imageKey
          }
          try {
            await this.login(params)
            await this.getUserPermission()
            const userInfo = window.storage.getItem(window.storage.keys.USER_INFO)
            if (userInfo.def1 !== undefined && userInfo.def1 !== null && userInfo.def1 !== '') {
              this.$router.push('/home')
            } else {
              me.passwordDialogShow = true
            }
          } catch (e) {
            console.log(e)
            this.getVerifyCode()
          }
        }
      })
    },
    getVerifyCode () {
      this.getImgVerifyCode().then(data => {
        this.imgCode = data
      })
    }
  },
  mounted () {
    // 判断是不是通过新能源油品库预警消息群中链接点击进来的
    const warnInfo = this.$route.query.warnInfo
    if (warnInfo) {
      // 判断是否钉钉环境内的链接
      if (dd.env.platform === 'notInDingTalk') {
        return false
      }
      // 符合条件，调用钉钉api获取点击用户的钉钉ID进行授权免登，跳转到预警信息录入界面
      this.isDingDing = true
      dd.ready(() => {
        dd.runtime.permission.requestAuthCode({
          corpId: 'ding2e1e6c6bcb870602',
          onSuccess: async (res) => {
            await this.ddLogin({ code: res.code })
            await this.getUserPermission()
            this.$router.push('/warehouseManager/xnyypk/warningHandle?warnInfo=' + warnInfo)
          }
        })
      })
      dd.error(function (error) {
        alert('dd error: ' + JSON.stringify(error))
      })
      return false
    }

    this.getRegionJson()

    if (dd && dd.pc) {
      this.isDingDing = true
      const me = this
      dd.ready(() => {
        dd.runtime.permission.requestAuthCode({
          corpId: 'ding2e1e6c6bcb870602',
          onSuccess: async (res) => {
            await this.ddLogin({ code: res.code })
            await this.getUserPermission()
            const userInfo = window.storage.getItem(window.storage.keys.USER_INFO)
            if (userInfo.def1 !== undefined && userInfo.def1 !== null && userInfo.def1 !== '') {
              this.$router.push('/home')
            } else {
              me.passwordDialogShow = true
            }
          }
        })
      })
      dd.error(function (error) {
        alert('dd error: ' + JSON.stringify(error))
      })
    } else {
      this.getVerifyCode()
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  background-color: $primary-bg-color;
  height: 100vh;

  .top-bar {
    background-color: #FFF;
    height: 70px;
    line-height: 70px;
    border-bottom: 2px solid $primary-color;
    padding: 0 26px;

    img {
      width: 145px;
      height: auto;
    }

    span {
      display: inline-block;
      border: 1px solid $primary-color;
      border-radius: 12px;
      margin-left: 10px;
      padding: 4px 10px;
      line-height: 16px;
      color: $primary-color;
    }
  }

  .container {
    width: 900px;
    margin: 0 auto;
    margin-top: 100px;

    .img-login {
      width: 500px;
      height: auto;
    }

    .login-panel {
      width: 360px;
      float: right;

      .title {
        text-align: center;
        font-size: 20px;
        font-weight: bold;
        color: $primary-color;
        margin-bottom: 27px;
      }

      .panel {
        height: 322px;
        background-color: #fff;
        padding: 30px 40px;

        .slogn {
          font-size: 20px;
          text-align: center;
          color: #666666;
          font-weight: bold;
          margin-bottom: 35px;
        }

        .submit {
          width: 100%;
        }

        .img-code {
          height: 30px;
          cursor: pointer;
        }
      }
    }
  }

  .auto-login{
    padding: 30px;
    line-height: 100px;
    font-size: 22px;
  }
}
</style>
